// @ is an alias to /src
import loginModal from "@/components/modals/loginModal/loginModal.vue"
import signUpModal from "@/components/modals/signUpModal/signUpModal.vue"
import successModal from "@/components/modals/successModal/successModal.vue"
import HomeSlider from "@/components/HomeSlider/HomeSlider.vue"
import Burger from "@/components/Burger/Burger.vue"

import {mapGetters} from "vuex"
import facebookLogin from 'facebook-login-vuejs';

export default {
    name: 'Home',
    data() {
        return {
            showLoginModal: false,
            showSuccessModal: false,
            showSignUpModal: false,
            headerFixed: false,
            showMobileMenu: false,
            closeBurgerMenu: false,
            isConnected: false,
            FB: false,
            errorAuth: false,
            successAuth: false,
        }
    },
    components: {
        loginModal,
        signUpModal,
        successModal,
        HomeSlider,
        Burger,
        facebookLogin
    },
    computed:
        mapGetters(['toogleLogin', 'toogleSignUp', 'toogleSuccess', 'isLoggedIn']),
    methods: {
        toSignUp: function() {
            this.modalActiveSign = 'signup';
            this.$store.dispatch('changeVisionLogin');
            this.$store.dispatch('changeVisionSignUp');
        },
        toLogin: function () {
            this.modalActiveSign = 'login'
            this.$store.dispatch('changeVisionSignUp')
            this.$store.dispatch('changeVisionLogin')
        },
        toogleLoginModal() {
            this.$store.dispatch('changeVisionLogin')
        },
        logout() {
            this.$store.dispatch('logout')
        },

        toogleSuccessModal() {
            this.$store.dispatch('changeVisionSuccess')
        },
        toogleSignUpModal() {
            this.$store.dispatch('changeVisionSignUp')
        },
        onScroll(e) {
            window.scrollY > 0 ? this.headerFixed = true : this.headerFixed = false
        },
        toggleBurger: function () {
            let burgerMenu = document.getElementById('burger-menu');
            //burgerMenu.classList.toggle("close");
            this.closeBurgerMenu = !this.closeBurgerMenu;
            this.showMobileMenu = !this.showMobileMenu;
        }
    },
    created() {
        window.addEventListener('scroll', this.onScroll);
        this.$store.dispatch('hideAllModals')
    },
}